
























































































import { BButton, BPopover, BProgress } from "bootstrap-vue";
import useCampaigns from "@/views/modules/engage/useCampaigns";
import { ref, watch } from "@vue/composition-api";

export default {
    components: {
        BButton,
        BPopover,
        BProgress,
    },
    setup() {
        const { fetchLimit, currentLimit, isLoadingLimits } = useCampaigns();

        // Fancy animation on opening the page
        const localCurrentLimit = ref({
            contacts: {
                limit: 0,
                currentValue: 0,
            },
            messages: {
                limit: 0,
                currentValue: 0,
            },
        });

        fetchLimit().then(() => {
            setTimeout(() => {
                localCurrentLimit.value.contacts.limit = currentLimit.value.contacts.limit;
                localCurrentLimit.value.contacts.currentValue = currentLimit.value.contacts.currentValue;
                localCurrentLimit.value.messages.limit = currentLimit.value.messages.limit;
                localCurrentLimit.value.messages.currentValue = currentLimit.value.messages.currentValue;
            }, 500);
        });

        const popoverShow = ref(false);
        const onPopoverClose = () => {
            popoverShow.value = false;
        };

        return {
            localCurrentLimit,
            isLoadingLimits,

            popoverShow,
            onPopoverClose,
        };
    },
};
